import React, { useCallback } from 'react';
import { getIn } from 'formik';

import Switch from '../../switch';
import { FieldElementPropTypes } from '../propTypes';

const SwitchField = ({
  field: { id, name, label, mode, value, onChange: customOnChange, ...props },
  ctx: { setFieldValue, classes, setFieldTouched, touched, errors }
}) => {
  const onChange = useCallback(
    (e) => {
      setFieldValue(name || id, e.target.checked);
      setFieldTouched(id, true, false);
      if (customOnChange) {
        customOnChange(name || id, e.target.checked);
      }
    },
    [setFieldTouched, setFieldValue, name, id, customOnChange]
  );
  return (
    <Switch
      key={id}
      id={id}
      name={name || id}
      value={!!value}
      mode={mode}
      label={label}
      classes={classes[id]}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) ? getIn(errors, name || id) : undefined}
      {...props}
    />
  );
};

SwitchField.propTypes = FieldElementPropTypes;

export default SwitchField;
